export default __webpack_public_path__ + "static/media/Snd5.034bbe42.mp3";